<div id="case-distribution" class="container-fluid pb-3">

    <div class="row" *ngIf="case">

        <!-- LEFT COLUMN WITH LIST -->

        <div class="col-sm-12 col-md-4">

            <mat-card>
                <mat-card-content>

                    <div class="row no-gutters">

                        <div class="info-message mt-3 mb-3" *ngIf="!activeDistributionJob"
                             align="center">{{ 'detailed_processing.distribution.message.make_selection' | translate }}
                        </div>

                        <mat-accordion class="full-width" *ngIf="activeDistributionJob">

                            <mat-expansion-panel class="mt-2"
                                                 *ngFor="let documentType of documentTypes"
                                                 id="{{idPrefix}}documents.{{documentType.key}}"
                                                 [expanded]="selectedDocumentType === documentType">
                                <mat-expansion-panel-header (click)="selectDocumentType(documentType)">

                                    <mat-panel-title>
                                        <div class="row full-width align-items-end">
                                            <div class="col-12">
                                                <span>{{ documentType.trans | translate }}</span>
                                                <span *ngIf="getDocumentCountForCategory(documentType.key)"
                                                      class="mat-badge-content mat-badge-active document-count-badge"
                                                      [ngClass]="{'selected': documentType === selectedDocumentType}">
                                                    {{getDocumentCountForCategory(documentType.key)}}
                                                </span>
                                            </div>
                                        </div>
                                    </mat-panel-title>

                                </mat-expansion-panel-header>

                                <file-selection-thumbnails-list *ngIf="documentType.key === CaseFileCategory.CLAIM_IMAGE.key"
                                                                class="full-width"
                                                                [idPrefix]="(idPrefix + 'documents.' + documentType.key + '.')"
                                                                [fileMetaList]="allAssignables.getFilesByCategory(documentType.key)"
                                                                [cdkDropListConnectedTo]="'distributionList'"
                                                                (onCdkFileDropped)="distributionJobListComponent.fileDropped($event)"
                                                                [category]="documentType.key"
                                                                (select)="distributionJobListComponent.addDocumentToDistributionJob($event)"
                                                                [disabled]="!activeDistributionJob.state ||
                                                                                   (activeDistributionJob.state !== DistributionJobState.INITIAL &&
                                                                                    activeDistributionJob.state !== DistributionJobState.ERROR_PREPARING)">
                                </file-selection-thumbnails-list>

                                <file-selection-list *ngIf="documentType.key !== CaseFileCategory.CLAIM_IMAGE.key"
                                                     class="full-width"
                                                     [idPrefix]="(idPrefix + 'documents.' + documentType.key + '.')"
                                                     [fileMetaList]="allAssignables.getFilesByCategory(documentType.key)"
                                                     [selected]="activeDistributionJob.selectedTemplateKeys"
                                                     [withIconAvatars]="true"
                                                     [cdkDropListConnectedTo]="'distributionList'"
                                                     (onCdkFileDropped)="distributionJobListComponent.fileDropped($event)"
                                                     [category]="documentType.key"
                                                     (select)="distributionJobListComponent.addDocumentToDistributionJob($event)"
                                                     [disabled]="!activeDistributionJob.state ||
                                                                        (activeDistributionJob.state !== DistributionJobState.INITIAL &&
                                                                         activeDistributionJob.state !== DistributionJobState.ERROR_PREPARING)">
                                </file-selection-list>

                            </mat-expansion-panel>

                        </mat-accordion>

                    </div>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH DISTRIBUTION -->

        <div class="col-sm-12 col-md-8 mt-xs-3 mt-sm-3 mt-md-0">

            <mat-card>
                <mat-card-content>

                    <div class="smp-title">{{ 'detailed_processing.distribution.title.distribution_jobs' | translate }}</div>

                    <div class="row mt-3 mb-3">
                        <div class="col-md-4 offset-md-8 col-sm-12">
                            <button mat-flat-button color="accent" class="full-width"
                                    id="{{idPrefix}}btn.create"
                                    (click)="createNewDistribution()">
                                {{ 'detailed_processing.distribution.btn.create_distribution_job' | translate | uppercase }}
                            </button>
                        </div>
                    </div>

                    <distribution-job-list #distributionJobListComponent
                                           *ngIf="distributionJobList && participants"
                                           [idPrefix]="idPrefix"
                                           [distributionJobList]="distributionJobList"
                                           [participants]="participants"
                                           [uriBuilderParamsFn]="generateCaseDistributionJobUriBuilderParams"
                                           (tellMyParents)="detectChanges()">
                    </distribution-job-list>
                </mat-card-content>
            </mat-card>

        </div>
    </div>

</div>
